import React from "react";
import "react-quill/dist/quill.snow.css"; // Quill এর স্টাইল ইম্পোর্ট
import { config } from "../../../../../config";

const imageUrl = config.imageUrl;

const UpdateHome = ({ formData,setFormData, handleChange, handleSubmit,onCancel, loading, error }) => {

    const handleItemChange = (index, value) => {
        const newItems = [...formData.items];
        newItems[index].items = value;
        setFormData(prev => ({
          ...prev,
          items: newItems
        }));
      };

      const addNewItem = () => {
        setFormData(prev => ({
          ...prev,
          items: [...prev.items, { items: "" }]
        }));
      };
    
      const removeItem = (index) => {
        const newItems = formData.items.filter((_, i) => i !== index);
        setFormData(prev => ({
          ...prev,
          items: newItems.length > 0 ? newItems : [{ items: "" }]
        }));
      };
  return (
    <div className="p-6 max-w-lg mx-auto bg-white shadow rounded">
      <h2 className="text-2xl font-bold mb-4">Update Secret</h2>

      {/* Display Loading State */}
      {loading && <p className="text-blue-500 mb-4">Updating...</p>}

      {/* Display Error Message */}
      {error && <p className="text-red-500 mb-4">{error}</p>}

      <form onSubmit={handleSubmit}>
        {/* Top Bar */}
        <div className="mb-4">
          <label className="block text-gray-700 font-medium">Slug</label>
          <input
            type="text"
            name="slug"
            value={formData.slug}
            onChange={handleChange}
            className="border w-full p-2"
            placeholder="Enter top bar text"
          />
        </div>

        {/* Headline */}
        <div className="mb-4">
          <label className="block text-gray-700 font-medium">Headline</label>
          <input
            type="text"
            name="headline"
            value={formData.headline}
            onChange={handleChange}
            className="border w-full p-2"
            placeholder="Enter headline"
            required
          />
        </div>

        {/* Items */}
        <div>
          <label className="block mb-1">Secret Items:</label>
          {formData.items.map((item, index) => (
            <div key={index} className="flex mb-2">
              <input
                type="text"
                value={item.items}
                onChange={(e) => handleItemChange(index, e.target.value)}
                className="flex-1 p-2 border rounded"
                required
              />
              <button
                type="button"
                onClick={() => removeItem(index)}
                className="ml-2 px-3 bg-red-500 text-white rounded"
              >
                Remove
              </button>
            </div>
          ))}
          <button
            type="button"
            onClick={addNewItem}
            className="mt-2 px-4 py-2 bg-blue-500 text-white rounded"
          >
            Add Item
          </button>
        </div>

        {/* Submit Button */}
         <div className="flex justify-end space-x-3">
             <button
              type="button"
              onClick={onCancel}
              className="bg-gray-500 text-white px-6 py-2 rounded hover:bg-gray-600"
              disabled={loading}
            >
              Cancel
            </button>
           <button
              type="submit"
              className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
              disabled={loading}
            >
              {loading ? "Updating..." : "Update Homepage"}
            </button>
        </div>
     
      </form>
    </div>
  );
};

export default UpdateHome;
